<template>
  <div class="logout_container"
  :class="custom_class"
  >
    
    <a href=""
    @click="log_out($event)"
    >Sign out</a>

  </div>
</template>

<script>

export default {
  name: 'logout_button',
  props: [
    'custom_class'
  ],
  data () {
    return {
      
    }
  },
  methods: {
    log_out: function(e) {
      e.preventDefault();

      this.$root.store.session.log_out();
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.logout_container {
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/features/login/logout_button.vue